import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("span", { class: "uv-modal-close-text" }, "CLOSE", -1)

import store from '@/store';
	import { Cross } from '@/svg';

	
export default /*#__PURE__*/_defineComponent({
  setup(__props) {

	const closeModal = () => {
		store.commit('resetEnquiryModal');
	}
	const handleCloseClick = (e: Event): void => {
		e.stopPropagation();
		closeModal();
	}
	const handleModalBgClick = (): void => {
		closeModal();
	};
	const handleModalContentClick = (e: Event): void => {
		if (!(e.target as Element).classList.contains('uv-enquiry-modal-slot-holder')){
			e.stopPropagation();
		}
	}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "uv-enquiry-modal-bg",
    role: "dialog",
    onClick: handleModalBgClick
  }, [
    _createElementVNode("a", {
      class: "uv-modal-close",
      onClick: handleCloseClick
    }, [
      _hoisted_1,
      _createVNode(_unref(Cross))
    ]),
    _createElementVNode("div", {
      class: "uv-enquiry-modal-slot-holder",
      onClick: handleModalContentClick
    }, [
      _renderSlot(_ctx.$slots, "default")
    ])
  ]))
}
}

})